export default function isIsoDate(str) {
  const regex = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)/
  if (!regex.test(str)) return false
  return true
}
